<template>
  <div v-wechat-title="title">
    <Header :extras="extras" platform="pc"></Header>
    <template v-if="!errorMessage && !showInWechat">
      <div class="question-main" :class="extraItem.extras('banner.bannerType')">
        <div
          class="question-title"
          :style="{
            display:
              extraItem.extras('titlefont.display') == 1 ? 'block' : 'none',
            color: extraItem.extras('titlefont.color'),
            fontSize: pxOrVw(extraItem.extras('titlefont.size')),
            fontWeight:
              extraItem.extras('titlefont.weight') == 'default'
                ? '500'
                : extraItem.extras('titlefont.weight'),
          }"
        >
          {{ title }}
        </div>
        <pc-fields
          :form="questionnaireList"
          :extras="extras"
          :rulesJump.sync="rulesJump"
          ref="questionChild"
        />
        <div class="question-footer" v-if="isShowBtn">
          <a-button
            type="primary"
            @click="submit()"
            :style="{
              backgroundColor:
                extraItem.extras('themecolor.bgcolor') === '#1665D8' &&
                extraItem.extras('submitfont.bgcolor')
                  ? extraItem.extras('submitfont.bgcolor')
                  : extraItem.extras('themecolor.bgcolor'),
              color: extraItem.extras('submitfont.color'),
            }"
          >
            <span v-if="extraItem.extras('submitfont.model')">{{
              extras | extra("submitfont.model")
            }}</span>
            <span v-if="!extraItem.extras('submitfont.model')">提交</span>
          </a-button>
        </div>
      </div>
    </template>
    <div class="m-currency-content" v-if="errorMessage && !showInWechat">
      <form-status
        :status="
          questionaryStatus == 0
            ? 'nostart'
            : questionaryStatus == 2
            ? 'over'
            : 'error'
        "
        :test="errorMessage"
        platform="pc"
      ></form-status>
    </div>
    <WeChat v-if="showInWechat" :qrcodeUrl="qrcodeUrl" />
    <CountDown
      ref="count-down"
      :extras="extras"
      platform="pc"
      :totalTimeM="
        questionnaireInfo.isTimeLimit == '2' ? questionnaireInfo.limitTime : 0
      "
      :costTime="costTime"
      @calibration="questionnaireTimeGet"
      @autoSubmit="submit"
    ></CountDown>
  </div>
</template>

<script>
import templateMixin from "../../../mixins/question-config";
import questionaryMixin from "../../../mixins/questionary";
import PcFields from "@/components/PcFields.vue";
export default {
  name: "pcQuestionnaire",
  components: {
    PcFields,
  },
  mixins: [templateMixin, questionaryMixin],
};
</script>

<style scoped></style>
